export default __webpack_public_path__ + "static/media/booster.d6dc253a.svg";